import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-women-cell',
  templateUrl: './women-cell.component.html',
  styleUrls: ['./women-cell.component.scss']
})
export class WomenCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
